const doLog = (process.env.VUE_APP_LOG_ENABLED === 'y');
const MAX_STR = 70;

// tslint:disable-next-line
const _log = console.log;

// log color
function lColor(v0: any, color: any, bgColor: any, ...vx: any) {
  _log(`%c${v0}`, `background: ${bgColor}; color: ${color}`, ...vx);
}

function maxStr(str: string) {
  str = '' + str;
  if (str.length > MAX_STR) {
    return str.substr(0, MAX_STR) + '...';
  }
  return str;
}

// vuex store commits
function lCommit(mutation: any) {
  if (!doLog) { return; }
  if (mutation.payload === undefined) {
    _log(`%c|%c C:`,
      `background: #fff; color: #000`,
      `background: #000; color: #ffff00`,
      mutation.type
    );
  }

  switch (typeof mutation.payload) {
    case 'string':
      return _log(`%c|%c C:`,
        `background: #fff; color: #000`,
        `background: #000; color: #ffff00`,
        mutation.type + '(' + maxStr(mutation.payload) + ')'
      );
  }
  return _log(`%c|%c C:`,
    `background: #fff; color: #000`,
    `background: #000; color: #ffff00`,
    mutation.type, mutation.payload
  );
}

// vuex store actions
function lAction(action: any) {
  if (!doLog) { return; }
  if (action.payload === undefined) {
    return lColor(` A >`, '#11ff11', '#000', action.type);
  }
  if (action.type === 'auth/login') {
    return lColor(` A >`, '#11ff11', '#000', action.type + '({...hidden...})');
  }

  switch (typeof action.payload) {
    case 'string':
      return lColor(` A >`, '#11ff11', '#000', action.type + '(' + maxStr(action.payload) + ')');
  }
  return lColor(` A >`, '#11ff11', '#000', action.type, action.payload);
}

function lCache(state: any, key: any) {
  if (!doLog) { return; }
  return lColor(`${state}`, '#1111ff', '#cc0', maxStr(key));
}

// namespaced log. Just add component name or whatever
function NSLog(name: string) {
  if (!doLog) {
    return (...args: any) => {
      // do nothing
    };
  }
  return (...vx: any) => {
    return lColor(name, '#1111ff', '#cc0', ...vx);
  };
}

// alias
const logColor = lColor;
const logCommit = lCommit;
const logAction = lAction;
const logCache = lCache;

export default {
  NSLog,
  color: logColor,
  commit: logCommit,
  action: logAction,
};
export {
  NSLog,

  logColor,
  lColor,

  lCommit,
  logCommit,

  lAction,
  logAction,

  lCache,
  logCache,
};
